<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>
<style>

    .float-left {
        float: left;
    }

    .float-right {
        float: right;
    }

    a {
        text-decoration: none;
    }

    #app {
        min-width: 1140px;
    }

    * {
        padding: 0;
        margin: 0;
    }

    .margin-bottom-20 {
        margin-bottom: 20px;
    }

    .margin-bottom-10 {
        margin-bottom: 10px;
    }

    .clearfix {
        overflow: auto;
        zoom: 1;
    }
    .tox-tinymce-aux{
        z-index: 100000 !important;
    }
</style>
